module.exports = __webpack_public_path__ + "img/done.e68391f3.png";